// extracted by mini-css-extract-plugin
module.exports = {"pageWrap":"home-module__pageWrap___o3Z3t"};